
import { defineComponent, nextTick, onMounted, ref, watch } from 'vue'
import { authState, clearCredentials, loginWithPassword, readCredentials, saveToken } from '@/utils/token'
import { refreshOverview } from '@/api/dashboard'

export default defineComponent({
  setup() {
    const mode = ref<'cred' | 'token'>('cred')
    const draft = ref('')
    const username = ref('')
    const password = ref('')
    const remember = ref(true)
    const error = ref('')
    const savedUsername = ref('')
    const inputRef = ref<HTMLInputElement | null>(null)

    // 已保存凭据时预填用户名，只差密码（或直接自动续期，通常看不到这一层）
    const prefill = () => {
      const saved = readCredentials()
      savedUsername.value = saved?.username || ''
      if (saved) {
        username.value = saved.username
        remember.value = true
      }
    }

    const focusInput = () => {
      nextTick(() => {
        const el = document.getElementById(mode.value === 'cred' ? 'cred-username' : 'token-input')
        el?.focus()
      })
    }

    watch(() => authState.promptVisible, (visible) => { if (visible) focusInput() })
    onMounted(() => { if (authState.promptVisible) { prefill(); focusInput() } })
    watch(() => authState.notice, (text) => { error.value = text || '' })

    const switchMode = (next: 'cred' | 'token') => {
      mode.value = next
      focusInput()
    }

    const submitToken = () => {
      if (!saveToken(draft.value)) return
      draft.value = ''
      // 输入后立即拉一次，不干等 5 分钟轮询
      refreshOverview()
    }

    const submitCredentials = async () => {
      error.value = ''
      try {
        await loginWithPassword(username.value.trim(), password.value, remember.value)
        password.value = ''
        prefill()
        refreshOverview()
      } catch (err) {
        error.value = (err as Error).message || '登录失败'
        authState.notice = error.value
      }
    }

    const forget = () => {
      clearCredentials()
      authState.autoRenew = false
      savedUsername.value = ''
      authState.notice = '已清除保存的凭据；仍可用当前 token 直到到期'
    }

    return {
      authState,
      mode,
      draft,
      username,
      password,
      remember,
      error,
      inputRef,
      savedUsername,
      switchMode,
      submitToken,
      submitCredentials,
      forget,
    }
  },
})
